import { QueryClientProvider } from '@tanstack/react-query';
import type { ReactNode } from 'react';
import { queryClient } from '@/libs/query-client';

export const QUERY_STALE_TIME_MS = 3 * 60 * 1000;

/**
 * マスタ系の一覧を1リクエストで取り切るためのページサイズ(APIの上限値)。
 * 同一画面で params が食い違うとクエリキーが分裂して同じ一覧を二重に取得するため、共有の定数を使う。
 */
export const FULL_LIST_PARAMS = { page_size: 500 } as const;

type QueryProviderProps = {
  children: ReactNode;
};

export const QueryProvider = ({ children }: QueryProviderProps) => {
  return <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>;
};
